import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBriefcase, faGraduationCap } from '@fortawesome/free-solid-svg-icons';
import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import '../assets/styles/Timeline.scss'

function Timeline() {
  return (
    <div id="history">
      <div className="items-container">
        <h1>Career History</h1>
        <VerticalTimeline>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: 'white', color: 'rgb(39, 40, 34)' }}
            contentArrowStyle={{ borderRight: '7px solid  white' }}
            date="2024 - present"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h2 className="vertical-timeline-element-title">Freelance Software Engineer</h2>
            <h3 className="vertical-timeline-element-title">AC Software LLC</h3>
            <h5 className="vertical-timeline-element-subtitle" >Remote</h5>
            <h4 className="vertical-timeline-element-subtitle">Boston, MA</h4>
            <p>
              Full-stack Web Development, Discord Bot Development, GenAI Solutions, Third-party API Integrations
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: 'white', color: 'rgb(39, 40, 34)' }}
            contentArrowStyle={{ borderRight: '7px solid  white' }}
            date="2024 - 2025"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faGraduationCap} />}
          >
            <h3 className="vertical-timeline-element-title">Bachelors in Computer Science Student</h3>
            <h4 className="vertical-timeline-element-subtitle">Boston, MA</h4>
            <p>
              Finished my bachelors degree with a added focus in cybersecurity, low level programming, and high performance computing.
              Build a distributed prime number generator using MPI,  a linux kernel module, 
              and a sub-10ms latency api using rust for a forum application build using angular
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="May 2024 - December 2024"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h2 className="vertical-timeline-element-title">Security Software Engineer Intern</h2>
            <h3 className="vertical-timeline-element-title">Siemens Healthineers</h3>
            <h5 className="vertical-timeline-element-subtitle">In Person</h5>
            <h4 className="vertical-timeline-element-subtitle">Seattle, WA</h4>
            <p>
              Security Software Development, Threat Detection, Incident Response
              Discovered and patched 15 vulnerabilities in Siemens Healthineers' ultrasound kiosk software, significantly enhancing the security of the product and protecting sensitive patient data.
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: 'white', color: 'rgb(39, 40, 34)' }}
            contentArrowStyle={{ borderRight: '7px solid  white' }}
            date="2021 - 2024"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faGraduationCap} />}
          >
            <h3 className="vertical-timeline-element-title">Bachelors in Computer Science Student</h3>
            <h4 className="vertical-timeline-element-subtitle">Boston, MA</h4>
            <p>
              Completed coursework in Data Structures, Algorithms, Computer Systems, Software Engineering, Databases, and Artificial Intelligence.
              Build a variety of projects including a full stack web application, a python data scraper, and syntax highlighting code editor.
            </p>
          </VerticalTimelineElement>
        </VerticalTimeline>
      </div>
    </div>
  );
}

export default Timeline;